import React from 'react';
import { InvoiceItemsList, useSendInvoicePrompt } from '../../../../../../../shared/ClientInvoiceItems';
import useOrganizationClientRecordInvoices from '../../../../../../../../hooks/api/useOrganizationClientRecordInvoices';
import useOrganizationClientRecordInvoiceItems from '../../../../../../../../hooks/api/useOrganizationClientRecordInvoiceItems';
import { AnimateLoadedContent } from '../../../../../../../v2BaseComponents/Loader';
import { SideDrawerButtonContainer } from '../../../../../../../v2BaseComponents/Form/SideDrawerFormContainer';
import { getIntl } from '../../../../../../../../utils/intl';

const intl = getIntl('client-invoice-items-list-content', {
    previewInvoice: 'Preview Invoice',
    sendInvoice: 'Send Invoice',
});

export type InvoiceItemsListContentOwnProps = {
    clientRecordId: string;
    onEditInvoiceLineItem: (invoiceItemId: string) => void;
    onAddInvoiceLineItem: () => void;
    onInvoiceSent: () => void;
    onEditBillingDetails: () => void;
};

export type InvoiceItemsListContentProps = InvoiceItemsListContentOwnProps;

const InvoiceItemsListContent: React.FC<InvoiceItemsListContentProps> = ({
    clientRecordId,
    onEditInvoiceLineItem,
    onAddInvoiceLineItem,
    onInvoiceSent,
    onEditBillingDetails,
}) => {
    const { invoiceItems } = useOrganizationClientRecordInvoiceItems({
        clientRecordId: clientRecordId,
    });
    const { isSendingInvoice, sendInvoice } = useOrganizationClientRecordInvoices({
        clientRecordId,
        onInvoiceSent,
    });
    const { Prompt, onPromptSendInvoice } = useSendInvoicePrompt({
        onSend: sendInvoice,
    });
    return (
        <AnimateLoadedContent isLoading={isSendingInvoice}>
            {() => (
                <>
                    <SideDrawerButtonContainer
                        buttons={[
                            {
                                title: intl('sendInvoice'),
                                onPress: onPromptSendInvoice,
                                isDisabled: isSendingInvoice,
                                variant: 'primary',
                                icon: 'Send',
                                shouldShow: !!invoiceItems?.items.length,
                                testID: 'send-invoice-button',
                            },
                        ]}
                        disablePadding
                    >
                        <InvoiceItemsList
                            clientRecordId={clientRecordId}
                            onEditInvoiceLineItem={onEditInvoiceLineItem}
                            onAddInvoiceLineItem={onAddInvoiceLineItem}
                            isInSideDrawer
                            onEditBillingDetails={onEditBillingDetails}
                        />
                    </SideDrawerButtonContainer>
                    {Prompt}
                </>
            )}
        </AnimateLoadedContent>
    );
};

export default React.memo(InvoiceItemsListContent);
